import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})

export class IndustryHighlightsService {
  private readonly industryHighlightsBaseApiUrl: string;

 
  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.industryHighlightsBaseApiUrl = `${baseUrl}api/industry-highlights`;
  }

  public getIndustryHighlights(industry: string) {
    let industryHighlightsApiUrl = `${this.industryHighlightsBaseApiUrl}/${industry}`;

    return this.dataService.get<any>(industryHighlightsApiUrl);
  } 
}
